"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameModeCardMove = void 0;
const CTGCard_1 = require("../Logic/CTGCard");
const CTGGameMode_1 = require("./CTGGameMode");
class CTGGameModeCardMove extends CTGGameMode_1.CTGGameMode {
    constructor(generator, animators = null, base_score) {
        super(animators);
        this.bounds = [[this.fixed_x_position(0), this.fixed_y_position(3)], [this.fixed_x_position(3), this.fixed_y_position(0)]];
        this.generator = generator;
        this.win_on_time_out = base_score === undefined;
        this.base_score = base_score;
    }
    reset() {
        super.reset();
        this.controlled_card = null;
    }
    target_score() {
        return Math.floor(this.base_score * (1 + this.difficulty));
    }
    generate_initial_cards(rand, difficulty) {
        let specs = this.generator.get_initial_cards(rand, difficulty);
        if (specs == null)
            specs = [];
        this.controlled_card = new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Diamonds, CTGCard_1.CTGRank.Ace);
        this.controlled_card.x = this.fixed_x_position(1.5);
        this.controlled_card.y = this.fixed_y_position(0);
        specs.push(this.controlled_card);
        return specs;
    }
    card_tapped(card) {
        // This is left blank to prevent the normal game mode behavior.
    }
    card_destroyed(card) {
        if (this.game_over) {
            return;
        }
        let cards = this.generator.card_destroyed(this.rand, this.difficulty, this.cards);
        if (cards != null && cards.length > 0) {
            this.cards_added(cards, true);
            this.emitEvent(CTGGameMode_1.CTGGameMode.EVENT_ADD_CARDS, { cards: cards });
        }
    }
    cards_generated(cards) {
    }
    time_ran_out() {
    }
    update_game(scene, now, delta, difficulty, mx, my, mdown) {
        mx = Math.max(this.bounds[0][0], Math.min(this.bounds[1][0], mx));
        my = Math.max(this.bounds[0][1], Math.min(this.bounds[1][1], my));
        let cards = this.cards.filter(x => x != this.controlled_card);
        let collided_cards = this.check_for_line_collisions(this.controlled_card.x, this.controlled_card.y, mx, my, this.controlled_card.rot, cards);
        this.controlled_card.move(mx, my);
        collided_cards.forEach(element => {
            if (element.tap_requirement == CTGCard_1.CTGTapRequirement.Dont) {
                this.lose([element]);
            }
            else {
                element.destroy(true, true);
                if (this.base_score) {
                    this.set_score(this.score + 1, (this.score + 1) / this.target_score());
                    if (this.score == this.target_score()) {
                        this.win();
                    }
                }
            }
        });
        let mode_cards = this.generator.update(this.rand, this.difficulty, now, delta);
        if (mode_cards != null && mode_cards.length > 0) {
            this.cards_added(mode_cards, true);
            this.emitEvent(CTGGameMode_1.CTGGameMode.EVENT_ADD_CARDS, { cards: mode_cards });
        }
    }
}
exports.CTGGameModeCardMove = CTGGameModeCardMove;
